import React from 'react';
import Head from 'next/head';
import { ForgotPasswordContainer } from '../../auth';
import { shared } from '../../config';

const sitekey = shared.GOOGLE_RECAPTCHA_SITE_KEY;

const ForgotPasswordPage = () => {
  return (
    <>
      <Head>
        <script
          type="text/javascript"
          src={`${shared.AWS_WAF_CHALLENGE_INTEGRATION_URL}`}
          defer
        />
      </Head>
      <ForgotPasswordContainer sitekey={sitekey} />
    </>
  );
};

ForgotPasswordPage.displayName = 'ForgotPasswordPage';

export default ForgotPasswordPage;
